import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import AddEmployeeForm from "../../components/pageManager/AddEmployeeForm";

const EmployeeManagerPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <AddEmployeeForm />
                </div>
            </div>
        </div>
    );
};

export default EmployeeManagerPage;
